










































































































































































































































































































































































































































































import Vue from "vue";
import _ from "lodash";
import { Form } from "element-ui";
import moment from "moment";
import config from "../config/index";
import { exportFiles, formatUrl, exportPostFiles } from "../common/util";
import { mapState, mapActions } from "vuex";
import store from "../store/store";
import { TaskData } from "../types/common";
import { PaperCheckData, OptData, CheckFileDto } from "../types/paperCheck";
import { uploadFileStatus } from "../common/filters";
import BatchImport from "@/components/paperCheck/BatchImport.vue";
import FileExtract from "@/components/paperCheck/FileExtract.vue";
import LibraryFind from "@/components/paperCheck/LibraryFind.vue";
import WarnDialog from "@/components/paperCheck/WarnDialog.vue";
Vue.component("BatchImport", BatchImport);
Vue.component("FileExtract", FileExtract);
Vue.component("LibraryFind", LibraryFind);
Vue.component("WarnDialog", WarnDialog);

declare var _hmt: any;
declare var captcha: any;

export default Vue.extend({
	name: "PaperCheck",
	data(): PaperCheckData {
		return {
			isTipsShow: false,
			isTips: false,
			tipText: `尊敬的用户你好，万方检测近期推出了毕业论文抽检系统V1.0.0版本，并在新版本中增加了如下新功能，欢迎使用：
<span style="display: block;text-indent: 2em;">•全新改版用户使用界面，优化交互设计</span>
<span style="display: block;text-indent: 2em;">•新增一对一检测功能，并提供一对一检测报告</span>
<span style="display: block;text-indent: 2em;">•全新改版检测报告，提升用户体验</span>`,
			isInitRule: false, // 是否需要初始化验证规则
			CheckSelfDBName: "",
			IsShowchache: false,
			checkSelfDBName: "",
			checkSelfDBId: "",
			isShowDBName: false,
			isShowChangeDb: false,
			isDb: false,
			isShowDbName: false,
			dbsList: [],
			checkdbidList: [],
			// paperType: 'newPaper',
			checkTypeLocal: "upload",
			isTraditional: false,
			isFolder: false,
			isShowFolderName: false,
			isOpenTips: true,
			isShowAddFolder: false,
			isShowAddDB: false,
			isAddFolder: false,
			oldFolderId: "",
			listLoading: false,
			isCheckResultTip: false,
			checkTime: 0,
			fileNum: 0,
			isCanCheck: false,
			checkIds: [],
			selectFileList: [],
			uploadFileList: [],
			copyUploadFileList: [],
			cacheUploadFileList: [],
			taskList: [],
			degree: "",
			degreeList: ["博士", "硕士", "学士"],
			infoFrom: "",
			multImportFile: "",
			multImport: false,
			fileExtract: false,
			degreeDate: "",
			submitFailed: false,
			statusMap: {
				SizeZero: "文件大小为0",
				SizeLimit: "文件大小超过限制",
				NotRegularName: "文件格式不符合要求",
				Error: "文本抽取失败",
				Over100WLimit: "送检文献内容超过100万字符",
				ExtractFail: "文本抽取失败",
				ExcelNoInfo: "获取论文信息失败",
			},
			$refs: {
				ruleForm: Form,
				folderForm: Form,
			},
			folderForm: {
				newTask: "",
				taskId: "",
				taskName: "",
			},
			folderRules: {
				taskName: [
					{
						required: true,
						validator: async (rule: any, value: any, callback: any) => {
							if (value === "") {
								callback(new Error("请输入文件夹名称"));
								return false;
							} else if (value.length > 50) {
								callback(new Error("文件夹名称不能大于50位"));
								return false;
							}
							if (await (this as any).checkTaskName()) {
								callback(new Error("该文件夹已存在"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				taskId: [
					{
						required: true,
						validator: (rule: any, value: any, callback: any) => {
							if (value === "") {
								callback(new Error("请选择文件夹"));
							} else {
								callback();
							}
						},
						trigger: "change",
					},
				],
			},
			ruleForm: {
				title: "",
				author: "",
				studentId: "",
				tutor: "",
				degreeDate: "",
				content: "",
			},
			localUploadForm: {
				title: "",
				author: "",
				checkId: "",
				publishTime: "",
			},
			ruleLocalUploadForm: {
				title: [
					{
						required: true,
						validator: (rule: any, value: any, callback: any) => {
							if (value === "") {
								callback(new Error("请填写题名"));
							} else if (value.length > 50) {
								callback(new Error("题名长度不超过50字符"));
							} else {
								callback();
							}
						},
						trigger: "change",
					},
				],
				author: [
					{
						required: false,
						validator: (rule: any, value: any, callback: any) => {
							if (value.length > 30) {
								callback(new Error("作者名称长度不超过30字符"));
							} else {
								callback();
							}
						},
						trigger: "change",
					},
				],
			},
			rules: {
				title: [
					{
						required: true,
						validator: (rule: any, value: any, callback: any) => {
							if (value === "") {
								callback(new Error("请填写题名"));
							} else if (value.length > 200) {
								callback(new Error("题名长度不能大于200个字符"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				author: [
					{
						required: true,
						validator: (rule: any, value: any, callback: any) => {
							if (value === "") {
								callback(new Error("请填写作者"));
							} else if (value.length > 150) {
								callback(new Error("作者名称长度不能大于150个字符"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				studentId: [
					{
						required: false,
						validator: (rule: any, value: any, callback: any) => {
							if (value.length > 30) {
								callback(new Error("学号名称长度不能大于30个字符"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				tutor: [
					{
						required: false,
						validator: (rule: any, value: any, callback: any) => {
							if (value.length > 30) {
								callback(new Error("导师名称长度不能大于30个字符"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				degreeDate: [
					{
						required: true,
						validator: (rule: any, value: string, callback: any) => {
							if (!value) {
								callback(new Error("请填写学位授予时间"));
							} else if (new Date(value) > new Date()) {
								callback(new Error("不能选择未发生的日期"));
							} else {
								callback();
							}
						},
						trigger: "change",
					},
				],
				content: [
					{
						required: true,
						validator: (rule: any, value: any, callback: any) => {
							if (value === "") {
								callback(new Error("请粘贴文本"));
							} else if (value.length > 1000000) {
								callback(new Error("检文献内容超过100万字符"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
			},
		};
	},
	computed: {
		...mapState({
			userInfo: (state: any) => store.getters.getUserInfo,
			checkType: (state: any) => store.getters.getCheckType,
			uploader: (state: any) => store.getters.getUploader,
		}),
		isCanUpload() {
			let result = true;
			if (!this.infoFrom || (this.infoFrom == "import" && !this.multImportFile) || (this.infoFrom == "extract" && !this.degreeDate) || this.degree === "") {
				result = false;
			} else {
				result = true;
			}
			return result;
		},
	},
	watch: {
		checkType(newVal) {
			this.checkTypeLocal = newVal;
		},
		checkTypeLocal: {
			immediate: true,
			handler(val) {
				setTimeout(() => {
					let setData: any = {};
					if (val === "upload") {
						let temp = localStorage.getItem("uploadSet");
						if (temp) setData = JSON.parse(temp);
						if (!this.uploadFileList.length) return;
					} else if (val === "operation") {
						let temp = localStorage.getItem("operateSet");
						if (temp) setData = JSON.parse(temp);
						return;
					} else if (val === "find") {
						let temp = localStorage.getItem("findSet");
						if (temp) setData = JSON.parse(temp);
						if (this.$refs.libraryfind && this.$refs.libraryfind.step !== 3 && this.$refs.libraryfind.step !== 4) return;
					}
					this.degree = setData.degree;
					if (setData.degreeDate) {
						this.infoFrom = "extract";
						this.degreeDate = setData.degreeDate;
					}
					if (setData.checkdbidList) {
						this.checkdbidList = setData.checkdbidList;
						this.isShowDBName = true;
						this.IsShowchache = true;
						this.isShowChangeDb = false;
						this.isDb = true;
						this.isShowDbName = true;
					}
					if (setData.taskId) {
						this.isShowFolderName = true;
						this.isAddFolder = true;
						this.isFolder = true;
						this.folderForm.taskId = setData.taskId;
						this.folderForm.taskName = setData.taskName;
					}
				}, 2000);
			},
		},
		// infoFrom(v: string) {
		//   switch(v) {
		//     case 'import':
		//       this.multImport = true
		//       break
		//     case 'extract':
		//       this.fileExtract = true
		//       break
		//   }
		// },
		isCanUpload(val) {
			if (val) {
				this.initUploader("#newPaper", {
					multiple: true,
					fileNumLimit: 500,
					type: "newPaper",
				});
			}
		},
	},
	mounted() {
		const cacheTips = localStorage.getItem("hdShowToast");
		let isShow = cacheTips ? JSON.parse(cacheTips) : this.isTips;
		if (!isShow) {
			this.isTipsShow = true;
		}
	},
	methods: {
		showUploadTip() {
			this.$message.error("请先完成“论文信息导入”设置再上传论文！");
		},
		chooseAllFail() {
			this.$refs.multipleTable.clearSelection();
			this.uploadFileList.map((it: any) => {
				if (it.fileState !== "Success" && it.fileState !== "waiting") {
					this.$refs.multipleTable.toggleRowSelection(it);
				}
			});
		},
		handleChangeDegree(val: string) {
			if (this.checkTypeLocal === "upload") {
				let uploadSet = localStorage.getItem("uploadSet");
				if (uploadSet) {
					let temp = JSON.parse(uploadSet);
					temp.degree = val;
					localStorage.setItem("uploadSet", JSON.stringify(temp));
				} else {
					localStorage.setItem(
						"uploadSet",
						JSON.stringify({
							degree: val,
						}),
					);
				}
			} else {
				let operateSet = localStorage.getItem("operateSet");
				if (operateSet) {
					let temp = JSON.parse(operateSet);
					temp.degree = val;
					localStorage.setItem("operateSet", JSON.stringify(temp));
				} else {
					localStorage.setItem(
						"operateSet",
						JSON.stringify({
							degree: val,
						}),
					);
				}
			}
		},
		// 修改弹出状态
		changeCacheTips() {
			this.isTipsShow = false;
			localStorage.setItem("hdShowToast", JSON.stringify(this.isTips));
		},
		// GetSelfDBStatus() {
		//   this.$http.get('/api/Setting/GetCheckDBIndexInfo')
		//     .then((data: any) => {
		//       if(data){
		//         this.CheckSelfDBName = data.data.dbStatus
		//       }
		//     })
		// },
		// 检测文件夹名称是否存在
		async checkTaskName(): Promise<any> {
			const { data } = await this.$http.get("/api/TaskManage/IsExistTask", {
				params: this.folderForm,
			});
			return data;
		},
		handleMultImport(val: boolean) {
			this.infoFrom = "import";
			this.multImport = true;
		},
		handleFileExtract(val: boolean) {
			this.infoFrom = "extract";
			this.fileExtract = true;
		},
		// 关闭对比库弹窗
		closeDbDialog() {
			if (!this.isShowDbName) {
				this.isDb = false;
			}
		},
		updateStorageDb() {
			if (this.checkTypeLocal === "upload") {
				let uploadSet = localStorage.getItem("uploadSet");
				if (uploadSet) {
					let temp = JSON.parse(uploadSet);
					temp.checkdbidList = this.checkdbidList;
					localStorage.setItem("uploadSet", JSON.stringify(temp));
				} else {
					localStorage.setItem(
						"uploadSet",
						JSON.stringify({
							checkdbidList: this.checkdbidList,
						}),
					);
				}
			} else if (this.checkTypeLocal === "operation") {
				let operateSet = localStorage.getItem("operateSet");
				if (operateSet) {
					let temp = JSON.parse(operateSet);
					temp.checkdbidList = this.checkdbidList;
					localStorage.setItem("operateSet", JSON.stringify(temp));
				} else {
					localStorage.setItem(
						"operateSet",
						JSON.stringify({
							checkdbidList: this.checkdbidList,
						}),
					);
				}
			} else {
				let findSet = localStorage.getItem("findSet");
				if (findSet) {
					let temp = JSON.parse(findSet);
					temp.checkdbidList = this.checkdbidList;
					localStorage.setItem("findSet", JSON.stringify(temp));
				} else {
					localStorage.setItem(
						"findSet",
						JSON.stringify({
							checkdbidList: this.checkdbidList,
						}),
					);
				}
			}
		},
		// 修改对比库（当前一次）
		intoDb() {
			this.changeDbStatus(false);
			this.isShowDBName = true;
			this.IsShowchache = true;
			this.isShowChangeDb = false;
			this.isDb = true;
			this.isShowDbName = true;

			this.updateStorageDb();
			this.submit();
		},
		// 是否修改对比库
		changeDbStatus(val: boolean) {
			if (!this.isDb) {
				this.isShowDbName = this.isDb;
				this.isShowDBName = false;
				this.getCheckDB();
			}
			this.isShowAddDB = val && !this.isShowDbName;
		},
		// 设置比对库
		submit() {
			this.$message({
				message: `设置成功`,
				type: "success",
			});
		},
		// 获取用户设置的比对库
		getCheckDB() {
			this.$http.get("/api/Setting/GetUserCheckDB").then((data: any) => {
				this.dbsList = [];
				this.checkdbidList = [];
				this.dbsList = data.data.wfdbIds;
				this.CheckSelfDBName = data.data.selfDBStatus;
				if (data.data.selfDBIsChecked) {
					let selfDB = data.data.selfDB,
						selfStatus = data.data.selfDBIsChecked,
						selfObj: object = {
							checkDBId: selfDB.checkSelfDBId,
							checkDBName: selfDB.checkSelfDBName,
							status: selfStatus,
						};
					this.dbsList.push(selfObj);
				}
				_.forEach(this.dbsList, (item: any) => {
					if (item.status) {
						this.checkdbidList.push(item.checkDBId);
					}
				});
			});
		},
		// 重置文件夹状态
		resetFolder() {
			this.isTraditional = false;
			this.isFolder = false;
			this.isShowFolderName = false;
			this.folderForm = {
				newTask: "",
				taskId: "",
				taskName: "",
			};
			this.resetForm("folderForm");
		},
		// 重置对比库状态
		resetConstDB() {
			this.isDb = false;
			this.isShowDbName = false;
			this.IsShowchache = false;
			this.isShowChangeDb = false;
			this.checkdbidList = [];
			this.getCheckDB();
		},
		// 修改检测类型触发方法
		changeCheckType() {
			this.resetConstDB();
			this.$store.dispatch("setCheckType", this.checkTypeLocal);
			this.resetFolder();
			this.resetForm("ruleForm");
		},
		// 修改文献类型触发方法
		changePaperType(type: string) {
			this.isShowChangeDb = false;
			this.$store.dispatch("setCheckType", "upload");
			this.$nextTick(() => {
				// dom加载完再初始化webuploader
				this.initUploader(`#${type}`, {
					multiple: type === "newPaper",
					fileNumLimit: type === "newPaper" ? 100 : 1,
					type,
				});
				this.resetFolder();
			});
		},
		// 修改温馨提示状态
		changeTipsStatus() {
			this.isOpenTips = !this.isOpenTips;
			// 记录用户操作
			localStorage.setItem("isOpenTips", this.isOpenTips.toString());
		},
		// 选择、取消上传文件钩子方法
		handleSelectionChange(val: CheckFileDto[]) {
			this.selectFileList = val;
			this.checkIds = [];
			_.forEach(this.selectFileList, (value: CheckFileDto) => {
				this.checkIds.push(value.checkId);
			});
		},
		// 删除选中文件
		delFileList(row?: any) {
			if (this.checkIds.length === 0 && !row) {
				this.$alert(" 请至少选择一条检测信息！", "提示");
				return false;
			}
			this.$confirm("是否确认删除？", "提示", { type: "warning" })
				.then(() => {
					let checkIdList: any[] = [];
					// 单个删除
					if (row) {
						this.uploadFileList = _.differenceWith(this.uploadFileList, [row], _.isEqual);
						checkIdList = [row.checkId];
					} else {
						// 批量删除
						this.uploadFileList = _.differenceWith(this.uploadFileList, this.selectFileList, _.isEqual);
						checkIdList = this.checkIds;
					}
					this.copyUploadFileList = this.uploadFileList.concat([]);
					this.$store.dispatch("setLoading", {
						isShow: true,
					});
					this.$http
						.delete("/api/HDCheck/DeleteFile", {
							data: {
								checkIds: checkIdList,
							},
						})
						.then((data: any) => {
							this.$store.dispatch("setLoading", {
								isShow: false,
							});
							this.handleSelectionChange([]);
							this.$message({
								message: `删除成功`,
								type: "success",
							});
							const delBtns: any = document.getElementsByClassName("deleteBtn");
							for (let i = 0; i < delBtns.length; i++) {
								delBtns[i].blur();
							}
							this.fileNum = this.uploadFileList.length;
						})
						.catch(() => {
							this.$store.dispatch("setLoading", {
								isShow: false,
							});
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消",
					});
					const delBtns: any = document.getElementsByClassName("deleteBtn");
					for (let i = 0; i < delBtns.length; i++) {
						delBtns[i].blur();
					}
				});
		},
		// 获取文件夹列表
		getTaskList() {
			this.$http.get("/api/TaskManage/GetTaskDropdownList").then((data: any) => {
				this.taskList = data.data;
			});
		},
		// 是否添加至文件夹
		changeFolderStatus(val: boolean) {
			if (!this.isFolder) {
				this.isShowFolderName = this.isFolder;
			}
			this.isShowAddFolder = val && !this.isShowFolderName;
		},
		// 关闭文件夹弹窗
		closeFolderDialog() {
			if (!this.isShowFolderName) {
				this.isFolder = false;
			}
		},
		// 改变文件夹类型事件
		changeFolderType() {
			this.$refs.folderForm.resetFields();
		},
		// 已有文件夹change事件
		changeTask(id: string) {
			let obj: TaskData | any = {};
			obj = this.taskList.find((item: TaskData) => {
				return item.taskId === id;
			});
			this.folderForm.taskName = (obj && obj.taskName) || "";
		},
		// 创建文件夹
		createFolder() {
			// const model = {taskName: this.folderForm.newTask}
			this.$http
				.post(`/api/TaskManage/CreateTask`, {
					taskName: this.folderForm.taskName,
				})
				.then((data: any) => {
					const result = data.data;
					Object.assign(this.folderForm, {
						taskId: result.taskId,
						taskName: result.taskName,
					});
					this.updateStorageFold();
					this.isAddFolder = true;
					this.getTaskList();
					this.$message({
						message: `创建成功`,
						type: "success",
					});
					this.isShowFolderName = true;
					this.changeFolderStatus(false);
				});
		},
		updateStorageFold() {
			if (this.checkTypeLocal === "upload") {
				let uploadSet = localStorage.getItem("uploadSet");
				if (uploadSet) {
					let temp = JSON.parse(uploadSet);
					temp.taskId = this.folderForm.taskId;
					temp.taskName = this.folderForm.taskName;
					localStorage.setItem("uploadSet", JSON.stringify(temp));
				} else {
					localStorage.setItem(
						"uploadSet",
						JSON.stringify({
							taskId: this.folderForm.taskId,
							taskName: this.folderForm.taskName,
						}),
					);
				}
			} else if (this.checkTypeLocal === "operation") {
				let operateSet = localStorage.getItem("operateSet");
				if (operateSet) {
					let temp = JSON.parse(operateSet);
					temp.taskId = this.folderForm.taskId;
					temp.taskName = this.folderForm.taskName;
					localStorage.setItem("operateSet", JSON.stringify(temp));
				} else {
					localStorage.setItem(
						"operateSet",
						JSON.stringify({
							taskId: this.folderForm.taskId,
							taskName: this.folderForm.taskName,
						}),
					);
				}
			} else {
				let findSet = localStorage.getItem("findSet");
				if (findSet) {
					let temp = JSON.parse(findSet);
					temp.taskId = this.folderForm.taskId;
					temp.taskName = this.folderForm.taskName;
					localStorage.setItem("findSet", JSON.stringify(temp));
				} else {
					localStorage.setItem(
						"findSet",
						JSON.stringify({
							taskId: this.folderForm.taskId,
							taskName: this.folderForm.taskName,
						}),
					);
				}
			}
		},
		// 添加至文件夹
		intoFolder() {
			this.$refs.folderForm.validate((valid: any) => {
				if (valid) {
					if (!this.isAddFolder) {
						this.createFolder();
					} else {
						this.isShowFolderName = true;
						this.changeFolderStatus(false);
						this.updateStorageFold();
					}
				}
			});
		},
		// 下载原文
		download(checkId: string) {
			this.$http
				.post(
					"/api/DetectResult/DownloadPaper",
					{
						checkId: checkId,
					},
					{
						responseType: "blob",
					},
				)
				.then((res: any) => {
					let headerFileName = res.headers["content-disposition"].split("filename*=UTF-8''")[1];
					headerFileName = decodeURIComponent(headerFileName);
					// post导出方法
					exportPostFiles(res.data, headerFileName);
				});
		},

		initRule() {
			if (this.isInitRule) {
				this.rules = {
					title: [
						{
							required: true,
							validator: (rule: any, value: any, callback: any) => {
								if (value === "") {
									callback(new Error("请填写题名"));
								} else if (value.length > 50) {
									callback(new Error("题名长度不能大于50个字符"));
								} else {
									callback();
								}
							},
							trigger: "blur",
						},
					],
					author: [
						{
							required: false,
							validator: (rule: any, value: any, callback: any) => {
								if (value.length > 30) {
									callback(new Error("作者名称长度不能大于30个字符"));
								} else {
									callback();
								}
							},
							trigger: "blur",
						},
					],
					studentId: [
						{
							required: false,
							validator: (rule: any, value: any, callback: any) => {
								if (value.length > 30) {
									callback(new Error("学号名称长度不能大于30个字符"));
								} else {
									callback();
								}
							},
							trigger: "blur",
						},
					],
					tutor: [
						{
							required: false,
							validator: (rule: any, value: any, callback: any) => {
								if (value.length > 30) {
									callback(new Error("导师名称长度不能大于30个字符"));
								} else {
									callback();
								}
							},
							trigger: "blur",
						},
					],
					content: [
						{
							required: true,
							validator: (rule: any, value: any, callback: any) => {
								if (value === "") {
									callback(new Error("请粘贴文本"));
								} else {
									callback();
								}
							},
							trigger: "change",
						},
					],
				};
			}
			this.isInitRule = false;
		},
		// 修改验证规则并立即触发(实现非预定义规则的错误提示)
		editRuleAndTriggerValid(msgList: any) {
			if (msgList) {
				(this.rules as any).content = [
					{
						validator: (rule: any, value: any, callback: any) => {
							callback(new Error("送检文献内容超过100万字符"));
						},
					},
				];
				this.validFrom("ruleForm");
			}
		},
		validFrom(fromType: any) {
			let res = false;
			this.$refs[fromType].validate((valid: any) => {
				if (!valid) {
					res = false;
				} else {
					res = true;
				}
			});
			return res;
		},
		// 获取未检测文件列表
		getNotCheckList() {
			this.$http.get("/api/HDCheck/GetNoCheckFileList").then((data: any) => {
				this.uploadFileList = data.data;
				this.uploadFileList.map((item: any) => {
					if (item.fileState !== "Success") {
						item.fileState = this.statusMap[item.fileState] ? this.statusMap[item.fileState] : "抽取失败";
					}
				});
				this.fileNum = this.uploadFileList.length;
				this.copyUploadFileList = this.uploadFileList.concat([]);
			});
		},
		// 开始检测
		async startCheck(type: string, formName?: string) {
			if (this.checkdbidList.length === 0) {
				this.$alert(" 请至少选择一个比对库！", "提示");
				return;
			}

			if (type === "upload" && (!this.infoFrom || (this.infoFrom == "import" && !this.multImportFile) || (this.infoFrom == "extract" && !this.degreeDate) || this.degree === "")) {
				this.$message.error("请先完成“论文信息导入”设置再上传论文！");
				return;
			}
			if (type === "operate" && this.degree === "") {
				this.$message.error("请先完成“论文信息导入”设置再上传论文！");
				return;
			}

			let upFailFile = this.uploadFileList.filter((it: any) => it.fileState !== "Success" && it.fileState !== "waiting");
			if (type === "upload" && upFailFile.length) {
				this.submitFailed = true;
				return;
			}

			if (!this.isDb) {
				await this.getCheckDB();
			}
			let param: any = {
				checkDBIds: this.checkdbidList.join(","),
			};
			this.folderForm.taskId ? (param.taskId = this.folderForm.taskId) : "";

			if (type === "upload") {
				if (this.uploadFileList.length === 0) {
					this.$alert(" 请先上传文献！", "提示");
					return false;
				}
				const mark = this.judgeStatus();
				if (!mark) {
					this.$alert("文件列表中包含上传失败的送检文献，请从列表中删除这些文献后再进行送检。", "提示");
					return false;
				}
				let checkIds: any[] = [];
				// 上传文件checkId集合
				checkIds = _.map(this.uploadFileList, "checkId");
				// 集合为空时提示
				if (_.isArray(checkIds) && checkIds.length !== 0) {
					this.$store.dispatch("setLoading", {
						isShow: true,
					});
					Object.assign(param, {
						checkIds,
						degreeType: this.degree,
					});

					this.infoFrom == "import" ? "" : (param.publishDate = this.degreeDate);

					// end
					// 无痕验证
					(param as any).nvc = captcha.getNVCVal();
					// end
					await this.$http
						.post("/api/HDCheck/ListCheck", param)
						.then((data: any) => {
							// 无痕验证未通过
							if (!captcha.callback(data.data)) {
								this.$store.dispatch("setLoading", {
									isShow: false,
								});
								return;
							} else if (data.data.success) {
								this.resetConstDB();
								this.$message({
									message: `送检成功`,
									type: "success",
								});
								// 重新更新全局状态
								this.$store.dispatch("setUserInfo");
								this.handleSelectionChange([]);
								localStorage.removeItem("uploadSet");
								this.getNotCheckList();
								this.checkTime = data.data.checkTime;
								this.isCheckResultTip = true;
							} else {
								if (data.data.message === "余额不足") {
									this.$alert("您的账户余额不足，请联系管理员充值!", "提示");
								} else if (data.data.message === "交易错误") {
									this.$alert("交易错误，请稍后重试!", "提示");
								} else {
									this.$message({
										message: data.data.message,
										type: "error",
									});
								}
								this.$store.dispatch("setUserInfo");
								this.handleSelectionChange([]);
								this.getNotCheckList();
							}
						})
						.catch(() => {
							this.$store.dispatch("setLoading", {
								isShow: false,
							});
						});
				} else {
					this.$message({
						message: "请选择上传文件",
						type: "error",
					});
				}
			} else {
				formName = formName || "";
				// 手工录入异步表单验证
				this.$refs[formName].validate((valid: any) => {
					if (valid) {
						this.$store.dispatch("setLoading", {
							isShow: true,
						});
						Object.assign(param, {
							...this.ruleForm,
							publishDate: this.ruleForm.degreeDate,
							degreeType: this.degree,
						});
						// end
						// 无痕验证
						(param as any).nvc = captcha.getNVCVal();
						// end
						this.$http
							.post("/api/HDCheck/Check2", param)
							.then((data: any) => {
								// 无痕验证未通过
								if (!captcha.callback(data.data)) {
									this.$store.dispatch("setLoading", {
										isShow: false,
									});
									return;
								} else if (data.data.success) {
									this.$message({
										message: `送检成功`,
										type: "success",
									});
									// 重新更新全局状态
									this.$store.dispatch("setUserInfo");
									this.resetForm(formName);
									localStorage.removeItem("operateSet");
									this.getNotCheckList();
									this.checkTime = data.data.waitTime;
									this.isCheckResultTip = true;
								} else {
									if (data.data.message === "送检文献内容超过<span style='color:red'>100万</span>字符") {
										this.editRuleAndTriggerValid(data.data.message);
										this.isInitRule = true;
									} else if (data.data.message === "余额不足") {
										this.$alert("您的账户余额不足，请联系管理员充值!", "提示");
									} else {
										this.$message({
											dangerouslyUseHTMLString: true,
											message: data.data.message,
											type: "error",
										});
									}
									this.$store.dispatch("setUserInfo");
									this.handleSelectionChange([]);
									this.getNotCheckList();
								}
							})
							.catch(() => {
								this.$store.dispatch("setLoading", {
									isShow: false,
								});
							});
					} else {
						return false;
					}
				});
			}
			// 重置
			this.resetFolder();
			this.resetConstDB();
		},
		// 清空、重置表单
		resetForm(formName: any) {
			if (this.$refs[formName]) {
				this.$refs[formName].resetFields();
			}
		},
		// 跳转到检测结果
		toCheckResult() {
			let path = "/myCheckInfo";
			this.$router.push({
				path,
			});
		},
		// 判断上传文件状态
		judgeStatus() {
			let mark = true;
			this.uploadFileList.forEach((item: any) => {
				if (item.fileState !== "Success") {
					mark = false;
				}
			});
			return mark;
		},
		// 上传成功回调
		handleSuccess(file: any, response: any) {
			if (response.success) {
				this.uploadFileList.forEach((item: any, index: any) => {
					if (file.id === item.id) {
						response.author = response.author;
						response.fileName = file.fileName;
						response.fileState = "Success";
						this.uploadFileList.splice(index, 1, response);
					}
				});
			} else {
				this.uploadFileList.forEach((item: any, index: any) => {
					if (file.id === item.id) {
						response.author = response.author;
						response.fileName = file.fileName;
						response.fileState = response.message;
						this.uploadFileList.splice(index, 1, response);
					}
				});
			}

			this.copyUploadFileList = this.uploadFileList.concat([]);
		},
		// 上传错误回调
		handleError(error: any, file: any, type: string) {
			if (error === "Q_TYPE_DENIED" && file.size !== 0) {
				this.$message({
					message: "文件格式不正确，仅限doc,docx,pdf",
					type: "error",
				});
			} else if (error === "F_EXCEED_SIZE") {
				// this.$message({
				//   message: `单个文件大小超过上限50M，请重新上传`,
				//   type: 'error'
				// });
			} else if (error === "Q_EXCEED_NUM_LIMIT") {
				this.$message({
					message: "上传文件数量已达单次上限，如还需上传请删除部分已上传文件",
					type: "error",
				});
			}
		},
		// 禁止上传提示
		tips() {
			this.$alert("当前还有未上传完的文档，请在完成后继续选择文档上传", "提示");
			return false;
		},
		// 初始化上传组件
		initUploader(domId: string, opt: OptData) {
			// 初始化前，如果有上传对象，清空上传队列
			if (this.uploader) {
				this.uploader.reset();
				this.getNotCheckList();
			}
			const webUploaderOpt = {
				auto: true, // 是否自动上传
				// fileSingleSizeLimit: opt.type === 'newPaper' ? 50 * 1024 * 1024 : undefined,
				// fileSingleSizeLimitStr: opt.type === 'newPaper' ? '50M' : undefined,
				fileNumLimit: opt.fileNumLimit,
				threads: 1,
				// swf文件路径
				swf: "/public/js/Uploader.swf?_t=" + new Date().getTime(),
				// 文件接收服务端。
				server: `${config.api}/api/HDCheck/Upload`,
				// 选择文件的按钮。可选。
				// 内部根据当前运行是创建，可能是input元素，也可能是flash.
				pick: {
					id: domId,
					multiple: opt.multiple,
				},
				// 不压缩image, 默认如果是jpeg，文件上传前会压缩一把再上传！
				resize: false,
				duplicate: true,
				accept: {
					title: "Documents",
					extensions: "doc,docx,pdf",
					mimeTypes: ".docx,.doc,.pdf",
				},
			};
			const WebUploader: any = (window as any).WebUploader;
			const uploader = WebUploader.create(webUploaderOpt);
			this.$store.dispatch("setUploader", uploader);
			uploader.on("uploadBeforeSend", (obj: any, data: any, headers: any) => {
				data.isOneByOne = false;
				data.useExcel = this.infoFrom == "import" ? true : false;
			});
			// 进入队列前触发
			uploader.on("beforeFileQueued", (file: any) => {});
			// 当有文件被添加进队列的时候
			uploader.on("fileQueued", (file: any) => {
				if (opt.type === "newPaper") {
					// 作者@题名
					const regex = /^([^@]+)@([^@]+)$/;
					// 学号@作者@题名@导师
					const regexs = /^([^@]+)@([^@]+)@([^@]+)@([^@]+)$/;
					if (regex.test(file.name)) {
						file.author = file.name.split("@")[0];
						file.fileName = file.name.split("@")[1].split(".")[0];
					} else if (regexs.test(file.name)) {
						file.author = file.name.split("@")[1];
						file.fileName = file.name.split("@")[2].split(".")[0];
					} else {
						file.fileName = file.name;
						let namee = file.name.split(".");
						if (namee.length > 1 && ["txt", "doc", "docx", "pdf", "rtf"].includes(namee[namee.length - 1])) {
							namee.splice(namee.length - 1, 1);
							file.fileName = namee.join();
						}
					}

					file.fileState = "waiting";
					// this.uploadFileList.push(file);
					this.cacheUploadFileList.push(file);
				}
				// 单篇上传加遮罩层
				if (!opt.multiple) {
					this.$store.dispatch("setLoading", {
						isShow: true,
						text: "正在上传，请稍后！",
					});
				}
			});

			uploader.on("startUpload", (file: any, response: any) => {
				if (this.fileNum + uploader.getFiles().length > 500 && opt.multiple) {
					this.$message({
						message: `本次只能上传${500 - this.fileNum}篇，如还需上传更多请删除部分已上传文件`,
						type: "error",
					});
					// this.uploadFileList = this.uploadFileList.slice(0, this.fileNum);
					uploader.reset();
					this.cacheUploadFileList = [];
				} else if (opt.multiple) {
					this.isCanCheck = true;
					this.fileNum = this.fileNum + uploader.getFiles().length;
					this.uploadFileList = this.uploadFileList.concat(this.cacheUploadFileList);
					this.copyUploadFileList = this.uploadFileList.concat([]);
				}
			});
			uploader.on("uploadSuccess", (file: any, response: any) => {
				if (!response) {
					this.$message({
						message: response.message,
						type: "error",
					});
					return false;
				}
				this.handleSuccess(file, response);
			});
			uploader.on("error", (error: any, file: any) => {
				this.handleError(error, file, opt.type);
			});
			uploader.on("uploadFinished", () => {
				this.isCanCheck = false;
				this.cacheUploadFileList = [];
				uploader.reset();
				this.$nextTick(() => {
					this.fileNum = this.uploadFileList.length;
					// 单篇上传加遮罩层
					if (!opt.multiple) {
						this.$store.dispatch("setLoading", {
							isShow: false,
							text: "正在加载...",
						});
					}
				});
			});
		},
	},
	created() {
		this.$store.dispatch("setCheckType", "upload");
		this.getTaskList();
		this.getNotCheckList();
		this.getCheckDB();
		this.$nextTick(() => {
			this.initUploader("#newPaper", {
				multiple: true,
				fileNumLimit: 500,
				type: "newPaper",
			});
		});
		// 获取用户操作
		this.isOpenTips = localStorage.getItem("isOpenTips") !== "false";
	},
});
